module.exports = __webpack_public_path__ + "img/宣威市第一人民医院.2086c929.png";